import { Link } from '@inertiajs/react'

export default function Show({ cart, wallet_balance }) {
  const csrfToken = () =>
    document.querySelector('[name="csrf-token"]')?.content || ''

  const spendable = wallet_balance?.spendable_vuu_cents || 0
  const subtotalCents = Math.round(Number(cart.subtotal) * 100)
  const hasSufficientFunds = spendable >= subtotalCents

  const handleConfirm = () => {
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = '/checkouts'
    const cartInput = document.createElement('input')
    cartInput.type = 'hidden'; cartInput.name = 'cart_id'; cartInput.value = cart.id
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'; csrfInput.name = 'authenticity_token'; csrfInput.value = csrfToken()
    form.appendChild(cartInput); form.appendChild(csrfInput)
    document.body.appendChild(form); form.submit()
  }

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Nav */}
        <div className="flex items-center justify-between mb-8">
          <Link href={`/web_carts/${cart.id}`} className="text-blue-600 hover:text-blue-800">
            ← Back to Cart
          </Link>
          <Link href="/wallet" className="text-blue-600 hover:text-blue-800 text-sm">
            Top up Wallet
          </Link>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-6">Checkout</h1>

        {/* Order summary */}
        <div className="bg-white rounded-xl shadow p-6 mb-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Order Summary</h2>
          <div className="divide-y divide-gray-100">
            {cart.items.map((item) => (
              <div key={item.id} className="py-3 flex justify-between">
                <span className="text-gray-700">{item.name} × {item.quantity}</span>
                <span className="font-semibold text-gray-900">
                  {Number(item.line_total).toFixed(2)} vuu
                </span>
              </div>
            ))}
          </div>
          <div className="flex justify-between text-xl font-bold text-gray-900 pt-4 border-t border-gray-200 mt-2">
            <span>Total</span>
            <span>{Number(cart.subtotal).toFixed(2)} vuu</span>
          </div>
        </div>

        {/* Wallet balance */}
        <div className={`rounded-xl shadow p-6 mb-6 ${hasSufficientFunds ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
          <h2 className="text-lg font-bold text-gray-900 mb-2">vuuCoin Balance</h2>
          <div className="flex justify-between">
            <span className="text-gray-600">Available</span>
            <span className={`font-bold text-lg ${hasSufficientFunds ? 'text-green-700' : 'text-red-700'}`}>
              {(spendable / 100).toFixed(2)} vuu
            </span>
          </div>
          <div className="flex justify-between mt-1">
            <span className="text-gray-600">Order Total</span>
            <span className="font-bold text-lg text-gray-900">
              {Number(cart.subtotal).toFixed(2)} vuu
            </span>
          </div>
          {!hasSufficientFunds && (
            <div className="mt-4">
              <p className="text-red-700 text-sm font-medium mb-2">
                Insufficient balance. Top up your wallet to continue.
              </p>
              <Link
                href="/wallet"
                className="inline-block bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg text-sm"
              >
                Top up Wallet →
              </Link>
            </div>
          )}
        </div>

        {/* Confirm */}
        <div className="bg-white rounded-xl shadow p-6">
          <p className="text-sm text-gray-500 mb-4">
            Payment will be deducted from your vuuCoin wallet.
            Settlement currency: <strong>vuu</strong>.
          </p>
          <button
            onClick={handleConfirm}
            disabled={!hasSufficientFunds}
            className={`w-full font-bold py-4 px-8 rounded-xl text-lg transition-colors ${
              hasSufficientFunds
                ? 'bg-blue-600 hover:bg-blue-700 text-white'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            {hasSufficientFunds ? 'Confirm & Pay' : 'Insufficient Balance'}
          </button>
        </div>
      </div>
    </div>
  )
}
